import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ProfitLossStatementComponent } from '@teem/profit-loss-statement/profit-loss-statement.component';


const routes: Routes = [
	{
		path: '',
		component: ProfitLossStatementComponent
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class ProfitLossStatementRoutingModule { }
